export function getPath(state) {
	var fullPath = "/settings";

	if (state.activeView) {
		fullPath += "/" + state.activeView;
	}

	return fullPath;
}

export function getRouteState(params) {
	var state = {};

	if (params.active_view) {
		state.activeView = params.active_view;
	}
	
	return state;
}

export var PATH = "/settings/:active_view?";


// WEBPACK FOOTER //
// ./modules/lib/routing/SettingsRouting.js